import { useState, type ReactNode } from 'react';
import { ReactComponent as TransactionDetailChevronIcon } from '../../../../../assets/icons/transaction-detail-chevron.svg';

interface TransactionDetailSectionProps {
  title: string;
  icon: ReactNode;
  defaultExpanded?: boolean;
  headerActions?: ReactNode;
  children: ReactNode;
}

const TransactionDetailSection = ({
  title,
  icon,
  defaultExpanded = false,
  headerActions,
  children,
}: TransactionDetailSectionProps) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <div
      className={`transaction_detail__card_section ${expanded ? '' : 'transaction_detail__card_section--collapsed'}`.trim()}
    >
      <div className="transaction_detail__title_section">
        <button
          type="button"
          className="transaction_detail__title_section__toggle"
          onClick={() => setExpanded(prev => !prev)}
          aria-expanded={expanded}
        >
          <span className="transaction_detail__title_section__text">
            {icon}
            {title}
          </span>
        </button>
        {headerActions && (
          <div className="transaction_detail__title_section__actions no_export" onClick={e => e.stopPropagation()}>
            {headerActions}
          </div>
        )}
        <button
          type="button"
          className="transaction_detail__chevron-btn"
          onClick={() => setExpanded(prev => !prev)}
          aria-expanded={expanded}
          aria-label={expanded ? 'Collapse section' : 'Expand section'}
        >
          <span
            className={`transaction_detail__chevron ${expanded ? 'transaction_detail__chevron--expanded' : ''}`}
            aria-hidden
          >
            <TransactionDetailChevronIcon />
          </span>
        </button>
      </div>
      {expanded && <div className="transaction_detail__section_body">{children}</div>}
    </div>
  );
};

export default TransactionDetailSection;
